import React from 'react';

class SMOSpaceEditBaseFragment extends React.Component {

  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }

  isCurrent(props){
    return props.selectedFragment == props.fragmentIndex;
  }

  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);

    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }

  didSelectNextFragment(e) {
    if(this.props.delegate && typeof this.props.delegate.nextButtonDidSelect === 'function'){
      this.props.delegate.nextButtonDidSelect();
    }
    e.preventDefault();
  }

  // delegate
  textFieldDidEndEditing(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  textAreaDidEndEditing(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  radioButtonDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  selectBoxDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  checkBoxDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  fileFieldDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  hiddenFieldDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.formDidUpdate === 'function'){
      this.props.delegate.formDidUpdate(e);
    }
  }

  googleMapDragEnd(e) {
    if(this.props.delegate && typeof this.props.delegate.googleMapDragEnd === 'function'){
      this.props.delegate.googleMapDragEnd(e);
    }
  }
}
export default SMOSpaceEditBaseFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditBaseFragment.jsx